import React from 'react';

import StrokeIcon, { StrokeIconProps } from './StrokeIcon';

export default function ArrowDownRightIcon(props: StrokeIconProps): JSX.Element {
  return (
    <StrokeIcon {...props}>
      <path d="m7 7 10 10" />
      <path d="M17 7v10H7" />
    </StrokeIcon>
  );
}
